import { palette } from './system/palette';

export const text = {
  'text.primary': palette['gray-900'],
  'text.secondary': palette['gray-600'],
  'text.quiet': palette['gray-500'],
  'text.redline': palette['red-650'],
};
